import { ComponentLoadingState, LoadingTypes } from '../modules/loading/reducer'

export const isLoading =
  (loadingState: ComponentLoadingState) => (label: LoadingTypes | string) =>
    (loadingState[label] || 0) > 0
